import {
    VuexModule,
    Module,
    Action,
    Mutation,
    getModule,
} from 'vuex-module-decorators';
import store from '@/store/store';
import config from '../../../config/service';
import socket from '@/api/websocket';

import overallSituationSocket from '@/api/OverallSituationWebsocker';
const socketUrl = 'http://192.168.1.182/' + config.webSocketService + '/imserver';

export interface IWebSocket {
    ws?: any,
}

@Module({ 'dynamic': true, store, 'name': 'websocket' })
class Websocket extends VuexModule implements IWebSocket {

    public ws?: any;

    @Mutation
    // 存储websocket对象
    public INIT_WEBSOCKET(ws: any) {
        this.ws = ws;
    }

    @Action
    // 连接websocket
    public initWebSocket(userId: any) {
        const ws = new socket(userId);
        // this.INIT_WEBSOCKET(ws);
        console.log(this.ws, 'wsi');
    }

    @Action
    public initOverallWebSocket(config: any,order: any){
        const situationSocket = new overallSituationSocket(config, order);
        this.INIT_WEBSOCKET(situationSocket);
    }

    @Action
    // 发送消息
    public sendMessage(data: any, callback: any) {
        // console.log(this.webSocket,'ws')
        this.ws.sendMessage(data, callback);
    }

}

export const WebsocketModule = getModule(Websocket);
